import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormGroup, FormBuilder } from '@angular/forms';
import { CountyRecord } from 'src/app/models/countyRecord';

@Component({
  selector: 'app-tableprofile',
  templateUrl: './tableprofile.component.html',
  styleUrls: ['./tableprofile.component.css']
})
export class TableprofileComponent implements OnInit {
  @Input() table: FormGroup;
  fieldList: string[] = [];
  
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.loadFieldsList();
  }

  loadFieldsList() {
    var rec: CountyRecord = new CountyRecord();

    for (const key in rec) {
      this.fieldList.push(key);
    }

    this.fieldList.sort((a,b) => a.localeCompare(b));

    this.fieldList.unshift('select');
  }

  get Columns() {
    return this.table.get('Columns') as FormArray;
  }
}
